import React from 'react';

export interface TrackGradientLegendProps {
  min: number;
  max: number;
  unit: string;
  divergent?: boolean;
  inverted?: boolean;
  className?: string;
}

export const TrackGradientLegend: React.FC<TrackGradientLegendProps> = ({
  min,
  max,
  unit,
  divergent = false,
  inverted = false,
  className = '',
}) => {
  const decimals = (unit === 'G' || unit === 'm/s²') ? 1 : 0;

  // Build CSS gradient string matching motorsport telemetry colors
  let gradientCss: string;
  if (inverted) {
    gradientCss = 'linear-gradient(to right, rgb(0, 255, 150), rgb(255, 200, 50), rgb(255, 0, 50))';
  } else if (divergent) {
    gradientCss = 'linear-gradient(to right, rgb(255, 0, 50), rgb(255, 200, 50) 50%, rgb(0, 255, 150))';
  } else {
    gradientCss = 'linear-gradient(to right, rgb(255, 0, 50), rgb(255, 200, 50), rgb(0, 255, 150))';
  }

  return (
    <div
      className={`flex items-center justify-center gap-3 py-1.5 px-4 rounded-full bg-bg-raised/80 backdrop-blur-md border border-border-subtle/80 shadow-lg text-xs mono mx-auto max-w-fit ${className}`}
    >
      <span className="text-[11px] font-medium text-text-secondary">
        {min.toFixed(decimals)}
      </span>
      <div className="relative flex flex-col items-center">
        <div
          className="w-24 sm:w-32 h-2 rounded-full shadow-inner"
          style={{ background: gradientCss }}
        />
        {divergent && (
          <span className="absolute -bottom-3.5 text-[9px] text-text-muted font-medium">
            0
          </span>
        )}
      </div>
      <span className="text-[11px] font-medium text-text-secondary">
        {max.toFixed(decimals)}{unit ? ` ${unit}` : ''}
      </span>
    </div>
  );
};
